import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { BasitNotEditComponent } from './basit-not-edit.component';
import { BasitNotKartComponent } from './basit-not-kart.component';
import { BasitNotKartSadeComponent } from './basit-not-kart-sade.component';

@DinamikBilesen({
  id: 'basit-not',
  baslik: 'Basit Not',
  aciklama: 'Hızlı not ve hatırlatma',
  ikon: 'edit',
  kategori: 'projeler',
})
class BasitNot {
  paylas_kutusu = BasitNotEditComponent;
  paylasilmis_kart = BasitNotKartComponent;
  paylasilmis_kart_sade = BasitNotKartSadeComponent;
}
